import React from "react";
import { withRouter } from "react-router-dom";
import { Container } from "react-grid-system";
import Select from "../../components/select/select_v2";
import GenericUpper from "../../components/generic-upper";
import Input from "../../components/input/input_v2";
import api from "../../services/api";
import identifyErrorMenssage from "../../services/identifyErrorMenssage";
import downloadFile from "../../utils/downloadFile";
import Button from "../../components/button/button_v2";
import { ArtsAddContainer } from "./styles";
import { store } from "react-notifications-component";
import ModalAlert from '../../components/modal/modalGeneric';

class EditArts extends React.Component {
    state = {
        agronomo_id: "",
        id: "",
        agronomos: [],
        creas: [],
        crea_id: "",
        crea_num: "",
        filial: "",
        numero_art: "",
        receita_inicial: "",
        quantidade_contratos: "",
        quantidade_receitas: "",
        validade_contratos: "",
        numero_ordem: "",
        data_validade: "",
        receitas_emitidas: "",
        estado: "",
        max: "",
        saldoArts: "",
        insestadual: '',
        responsavel_tecnico: "",
        status: '',
        erroReceitaInicial: false,
        erroNumeroArt: false,
        loading: false,
        loadingR: false,
        loadingT: false,
        sendAlert: true,
        showModalIe: false,
        opStatus: [
            { value: 1, label: "Ativo" },
            { value: 0, label: "Inativo" },
            { value: 2, label: "Vencida" }
        ],
        estados: [
            { value: "NACIONAL", label: "Nacional" },
            { value: "SP", label: "São Paulo" },
            { value: "RJ", label: "Rio de Janeiro" },
            { value: "SC", label: "Santa Catarina" },
            { value: "AC", label: "Acre" },
            { value: "AL", label: "Alagoas" },
            { value: "AP", label: "Amapa" },
            { value: "AM", label: "Amazonas" },
            { value: "BA", label: "Bahia" },
            { value: "CE", label: "Ceará" },
            { value: "DF", label: "Distrito Federal" },
            { value: "ES", label: "Espirito Santo" },
            { value: "GO", label: "Goiás" },
            { value: "MA", label: "Maranhão" },
            { value: "MT", label: "Mato Grosso" },
            { value: "MS", label: "Mato Grosso do Sul" },
            { value: "MG", label: "Minas Gerais" },
            { value: "PA", label: "Pará" },
            { value: "PB", label: "Paraíba" },
            { value: "PR", label: "Paraná" },
            { value: "PE", label: "Pernambuco" },
            { value: "PI", label: "Piaui" },
            { value: "RN", label: "Rio Grande do Norte" },
            { value: "RS", label: "Rio Grande do Sul" },
            { value: "RO", label: "Rondônia" },
            { value: "RR", label: "Roraima" },
            { value: "SE", label: "Sergipe" },
            { value: "TO", label: "Tocantins" },
            { value: "", label: "" }
        ],
        qtd_avisar: 0,
        apelido: "",
        allow_edit: true,
        allow_edit_validade: true,
        allow_edit_quantidade: true,
        min_quantidade_receitas: 0,
        min_quantidade_contratos: 0
    };

    componentDidMount() {
        this.getArts();
    }

    formatDataForInput = (data) => {
        if (!data) return '';
        const date = new Date(data);
        const year = date.getUTCFullYear();
        const month = String(date.getUTCMonth() + 1).padStart(2, '0');
        const day = String(date.getUTCDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    };

    getArts = async () => {
        try {
            const id = this.props.match.params.id;
            this.setState({ id });

            const response = await api.get(`/arts/${id}`);
            const arts = response.data.data;

            let status = arts.status;

            let dataValidade = arts.data_validade !== null ? this.formatDataForInput(arts.data_validade) : '';

            const estadoArt = arts.agro_creas?.estado || "SP";

            this.setState({
                saldoArts: arts.qtd_avisar != null && arts.qtd_avisar !== '' ? arts.qtd_avisar : false,
                sendAlert: arts.avisar === 1,
                crea_num: arts.agro_creas?.crea || "",
                crea_id: arts.agro_creas?.id || null,
                numero_art: arts.numero_art || "",
                numero_ordem: arts.numero_ordem || "",
                data_validade: dataValidade || "",
                quantidade_contratos: arts.quantidade_contratos || 0,
                quantidade_receitas: arts.quantidade_receitas || 0,
                receitas_emitidas: arts.receitas_emitidas || 0,
                receita_inicial: arts.receita_inicial_new ?? arts.receita_inicial_cfta ?? arts.receita_inicial,
                responsavel_tecnico: arts.agro_creas?.agro_agronomists?.nome || "",
                estado: estadoArt,
                status: status ?? 0,
                qtd_avisar: arts.qtd_avisar != null ? arts.qtd_avisar : 0,
                apelido: arts.apelido || "",
                allow_edit: arts.allow_edit !== false,
                allow_edit_validade: arts.allow_edit_validade !== false,
                allow_edit_quantidade: arts.allow_edit_quantidade !== false,
                min_quantidade_receitas: Number(arts.min_quantidade_receitas ?? arts.receitas_emitidas ?? 0),
                min_quantidade_contratos: Number(arts.min_quantidade_contratos ?? arts.qtd_contracts ?? 0),
            });
            
            // Busca configuração de limites (min/max contratos/receitas) para o estado da ART,
            // igual à tela de cadastro
            if (estadoArt) {
                try {
                    const resMax = await api.get(`/maxcontratos/${estadoArt}`);
                    if (resMax?.data?.data) {
                        this.setState({ max: resMax.data.data });
                    }
                } catch (e) { }
            }

        } catch (error) {
            store.addNotification({
                title: "Erro!",
                message: identifyErrorMenssage(
                    error,
                    "ERRO-622 Erro ao carregar os dados da ART - Tente novamente, se o erro persistir acione o suporte."
                ),
                type: "danger",
                insert: "top",
                container: "top-right",
                animationIn: ["animated", "fadeIn"],
                animationOut: ["animated", "fadeOut"],
                dismiss: {
                    duration: 4000,
                    onScreen: true
                }
            });
        }
    };

    editArt = async () => {
        this.setState({ loading: true });
        try {
            const {
                crea_id,
                saldoArts,
                numero_ordem,
                data_validade,
                numero_art,
                estado,
                quantidade_contratos,
                quantidade_receitas,
                receitas_emitidas,
                receita_inicial,
                qtd_avisar,
                apelido,
                erroReceitaInicial,
            } = this.state;

            const qtdAvisarNum = (v) => {
                if (v == null || v === '') return null;
                const n = typeof v === 'object' && v !== null && 'value' in v ? v.value : v;
                const num = Number(n);
                return Number.isFinite(num) ? num : null;
            };
            const qtdAvisarPayload = qtdAvisarNum(qtd_avisar) ?? qtdAvisarNum(saldoArts) ?? null;

            if (estado === "RS") {
                const numeroArtValido = /^[A-Za-z0-9]{7,10}$/.test(String(numero_art || "").trim());
                if (!numeroArtValido) {
                    this.setState({ loading: false, erroNumeroArt: true });
                    store.addNotification({
                        title: "Erro!",
                        message: "O número da ART deve ter 7 a 10 caracteres (ex: 1234567890).",
                        type: "danger",
                        insert: "top",
                        container: "top-right",
                        animationIn: ["animated", "fadeIn"],
                        animationOut: ["animated", "fadeOut"],
                        dismiss: {
                            duration: 4000,
                            onScreen: true
                        }
                    });
                    return;
                }
            }

            const statusValue = (this.state.status && typeof this.state.status === 'object')
                ? this.state.status.value
                : this.state.status;

            const payload = {
                creaId: crea_id,
                numero_ordem: numero_ordem || 0,
                numero_art,
                estado,
                quantidade_contratos: quantidade_contratos || 0,
                quantidade_receitas: quantidade_receitas || 0,
                receitas_emitidas: Number(receitas_emitidas ?? 0),
                receita_inicial,
                apelido: apelido || null,
                data_validade: data_validade || null,
                status: statusValue,
                qtd_avisar: qtdAvisarPayload,
                avisar: this.state.sendAlert ? 1 : 0,
            };
            const response = await api.put(`/arts/${this.state.id}`, payload);
            this.setState({ loading: false });

            store.addNotification({
                title: "Sucesso!",
                message: `A ART foi editada corretamente!`,
                type: "success",
                insert: "top",
                container: "top-right",
                animationIn: ["animated", "fadeIn"],
                animationOut: ["animated", "fadeOut"],
                dismiss: {
                    duration: 4000,
                    onScreen: true
                }
            });
            this.props.history.push('/arts');
            this.setState({ loading: false });


        } catch (error) {
            this.setState({ loading: false });

            const msg = identifyErrorMenssage(
                error,
                "Erro ao editar a ART/TRT."
            );

            // Se o backend devolver erro relacionado à Receita Inicial, marca o campo como inválido
            if (typeof msg === 'string' && (
                msg.includes('Receita Inicial') ||
                msg.includes('Receita inicial') ||
                msg.includes('numeração é inválida para a Receita Inicial') ||
                msg.includes('Formato inválido da Receita Inicial')
            )) {
                this.setState({ erroReceitaInicial: true });
            }

            // ERRO-680: Número ART inválido para RS
            if (typeof msg === 'string' && msg.includes('ERRO-680')) {
                this.setState({ erroNumeroArt: true });
            }

            store.addNotification({
                title: "Erro!",
                message: msg,
                type: "danger",
                insert: "top",
                container: "top-right",
                animationIn: ["animated", "fadeIn"],
                animationOut: ["animated", "fadeOut"],
                dismiss: {
                    duration: 4000,
                    onScreen: true
                }
            });
        }
    }

    relarioBaixaTrt = async () => {
        this.setState({ loadingR: true });
        try {
            const response = await api.get(`/arts/relatorio/${this.state.id}`);

            if (response && response.status === 200) {
                await downloadFile(response.data.data, 'TRT.pdf');
                this.setState({ loadingR: false });
            }
        } catch (error) {
            if (error?.response?.status == 402) {
                this.setState({ showModalIe: true });
            }

            this.setState({ loadingR: false });
            store.addNotification({
                title: "Erro!",
                message: identifyErrorMenssage(
                    error,
                    "ERRO-623 Erro ao gerar o relatorio para baixa de TRT - Tente novamente, se o erro persistir acione o suporte."
                ),
                type: "danger",
                insert: "top",
                container: "top-right",
                animationIn: ["animated", "fadeIn"],
                animationOut: ["animated", "fadeOut"],
                dismiss: {
                    duration: 4000,
                    onScreen: true
                }
            });
        }
    }

    enviaInscricao = async (insestadual) => {
        this.setState({ loadingT: true });
        if (insestadual && insestadual != "") {
            try {
                const response = await api.post(`/arts/relatorio/${this.state.id}`, {
                    ie: insestadual,
                });

                if (response) {
                    this.setState({ showModalIe: false });
                    this.relarioBaixaTrt();
                }
            } catch (error) {
                store.addNotification({
                    title: "Erro!",
                    message: identifyErrorMenssage(
                        error,
                        "ERRO-624 Erro ao enviar a inscricao estadual - Tente novamente, se o erro persistir acione o suporte."
                    ),
                    type: "danger",
                    insert: "top",
                    container: "top-right",
                    animationIn: ["animated", "fadeIn"],
                    animationOut: ["animated", "fadeOut"],
                    dismiss: {
                        duration: 4000,
                        onScreen: true
                    }
                });
            }
        }
        this.setState({ loadingT: false });

    }

    goBack = () => {
        this.props.history.goBack();
    }

    addContract = () => {
        this.props.history.push(`/contracts/${this.props.match.params.id}`);
    }

    changeSendAlert = (e) => {
        if (e) {
            this.setState({
                sendAlert: e
            })
        } else {
            this.setState({
                sendAlert: e,
                qtd_avisar: null,
                saldoArts: false
            })
        }
    }

    render() {
        const {
            crea_num,
            responsavel_tecnico,
            numero_art,
            numero_ordem,
            data_validade,
            quantidade_contratos,
            quantidade_receitas,
            receitas_emitidas,
            receita_inicial,
            validade_contratos,
            estado,
            saldoArts,
            sendAlert,
            insestadual,
            apelido,
            allow_edit,
            allow_edit_validade,
            allow_edit_quantidade,
            min_quantidade_receitas,
            min_quantidade_contratos,
            erroReceitaInicial,
            max
        } = this.state;
        return (
            <>
                <GenericUpper
                    title="Edite a ART/TRT"
                    subtitle="Edite esta ART/TRT"
                ></GenericUpper>
                <ArtsAddContainer>
                    <Container>
                        <form>
                            {/* <Select
                                name="estado"
                                label="Estado"
                                className="select"
                                disabled
                                value={estado}
                                options={this.state.estados}
                                onChange={() => console.log('')}
                            /> */}

                            {/* <Input
                                name="agronomos"
                                label="Responsável Técnico"
                                className="select"
                                disabled
                                value={responsavel_tecnico}
                                marginBottom="0"
                            /> */}

                            <Input
                                name="apelido"
                                label="Apelido"
                                type="text"
                                id="apelido"
                                value={apelido}
                                onChange={(e) => this.setState({ apelido: e })}
                                marginBottom="0"
                            />

                            <Input
                                name="numero-art"
                                type="text"
                                disabled={!allow_edit}
                                label="Número ART/TRT"
                                labelWithAsterisk={true}
                                value={numero_art}
                                erro={this.state.erroNumeroArt}
                                onChange={(e) => allow_edit && this.setState({ numero_art: e, erroNumeroArt: false })}
                                onBlur={() => {
                                    if (!allow_edit || estado !== "RS") return;
                                    const valor = String(this.state.numero_art || "").trim();
                                    if (!valor) return;
                                    this.setState({ erroNumeroArt: !/^[A-Za-z0-9]{7,10}$/.test(valor) });
                                }}
                                marginBottom={allow_edit ? "19px" : "0"}
                                legenda={allow_edit && estado === "RS" ? 'O número da ART deve ter 7 a 10 caracteres (ex: 1234567890).' : ""}
                            />

                            <Input
                                name="validade-art"
                                type="date"
                                label="Data de Validade"
                                id="validade_art"
                                disabled={!allow_edit_validade}
                                mask="99/99/9999"
                                value={data_validade}
                                onChange={(e) => allow_edit_validade && this.setState({ data_validade: e })}
                                marginBottom={allow_edit_validade ? "19px" : "0"}
                                legenda={allow_edit_validade && !allow_edit ? "A vigência pode ser alterada mesmo com receitas já emitidas. As receitas existentes e a numeração não são afetadas." : ""}
                            />

                            {(estado === "SP") ? <>
                                <Input
                                    name="quantidade-contratos"
                                    type="number"
                                    disabled={!allow_edit_quantidade}
                                    label="Contratos adquiridos"
                                    labelWithAsterisk={true}
                                    value={quantidade_contratos}
                                    onChange={(e) => allow_edit_quantidade && this.setState({ quantidade_contratos: e })}
                                    marginBottom={allow_edit_quantidade ? "24px" : "0"}
                                    legenda={allow_edit_quantidade ? (
                                        !allow_edit
                                            ? `Esta ART já possui contratos emitidos. O valor não pode ser menor que ${min_quantidade_contratos} (já utilizados) e nem maior que ${max?.max_contratos || "Não há"}.`
                                            : max?.min_contratos == null || max?.min_contratos === 0
                                                ? `De 1 a ${max?.max_contratos || "Não há"} contratos`
                                                : `Informe a quantidade de Contratos que foram adquiridos na compra desta ART. Insira um valor entre ${max.min_contratos} a ${max.max_contratos || "Não há"}.`
                                    ) : ""}
                                />

                                <Input
                                    name="numero-ordem"
                                    type="number"
                                    disabled={!allow_edit}
                                    label="Contratos já utilizados"
                                    labelWithAsterisk={true}
                                    value={numero_ordem}
                                    onChange={(e) => allow_edit && this.setState({ numero_ordem: e })}
                                    marginBottom={allow_edit ? "24px" : "0"}
                                    legenda={allow_edit ? "Informe a quantidade de Contratos que já foram utilizadas nesta ART até o momento. Se nenhum Contrato foi utilizado nesta ART, insira o número 0." : ""}
                                />
                            </> : (
                                <>
                                    <Input
                                        name="quantidade-receitas"
                                        type="text"
                                        label="Receitas adquiridas"
                                        labelWithAsterisk={true}
                                        disabled={!allow_edit_quantidade}
                                        value={quantidade_receitas}
                                        onChange={(e) => allow_edit_quantidade && this.setState({ quantidade_receitas: e })}
                                        marginBottom={allow_edit_quantidade ? "24px" : "0"}
                                        legenda={allow_edit_quantidade ? (
                                            !allow_edit
                                                ? `Esta ${estado === "NACIONAL" ? "TRT" : "ART"} já possui receitas emitidas. O valor não pode ser menor que ${min_quantidade_receitas} (já utilizadas) e nem maior que ${max?.max_receitas || "Não há"}.`
                                                : `Informe a quantidade de Receitas que foram adquiridas na compra desta ${estado === "NACIONAL" ? "TRT" : "ART"}. Insira um valor entre ${max?.min_receitas ? `${max.min_receitas} a ${max.max_receitas || "Não há"}` : `1 a ${max?.max_receitas || "Não há"}`}.`
                                        ) : ""}
                                    />

                                    <Input
                                        name="receitas-emitidas"
                                        type="text"
                                        disabled={!allow_edit}
                                        label="Receitas já utilizadas"
                                        labelWithAsterisk={true}
                                        value={receitas_emitidas}
                                        onChange={(e) => allow_edit && this.setState({ receitas_emitidas: e })}
                                        marginBottom={allow_edit ? "24px" : "0"}
                                        legenda={allow_edit ? `Informe a quantidade de Receitas que já foram utilizadas nesta ${estado === "NACIONAL" ? "TRT" : "ART"} até o momento. Se nenhuma Receita foi utilizada nesta ${estado === "NACIONAL" ? "TRT" : "ART"}, insira o número 0.` : ""}
                                    />
                                </>
                            )}

                            <Input
                                name="receita-inicial"
                                type="text"
                                disabled={!allow_edit}
                                label="Número da Receita inicial"
                                labelWithAsterisk={true}
                                value={receita_inicial}
                                erro={erroReceitaInicial}
                                onChange={(e) => allow_edit && this.setState({ receita_inicial: e, erroReceitaInicial: false })}
                                marginBottom={allow_edit ? "24px" : "0"}
                                legenda={allow_edit && estado !== "NACIONAL" ? (
                                    estado === "MS"
                                        ? "Informe o número da primeira Receita desta ART. Ex: B00522025021670."
                                        : estado === "RS"
                                        ? `Informe o número da primeira Receita que será emitida no AgroReceita. Veja um exemplo: ${estado}00001, ou somente números, ex: 0000001.`
                                        : ["AP", "AM", "CE", "PA", "RN"].includes(estado)
                                        ? `Informe o número da primeira Receita que será emitida no AgroReceita. Formato obrigatório: ${estado}202601RA000001.`
                                        : `Informe o número da primeira Receita que será emitida no AgroReceita. Veja um exemplo: ${estado}202601RA000001, ou somente números, ex: 1.`
                                ) : ""}
                            />

                            <Select
                                name="status"
                                className="text"
                                label="Status"
                                id="status"
                                value={this.state.status.value || this.state.status}
                                disabled={false}
                                onChange={e => this.setState({ status: e })}
                                options={this.state.opStatus}
                                selectUniqueOption={true}
                                erro={false}
                                marginBottom={allow_edit ? "40px" : "26px"}
                                labelWithAsterisk={true}
                            />

                            <Select
                                marginBottom="44px"
                                name="saldoArts"
                                className="select"
                                label="Me avisar quando o saldo estiver a partir de:"
                                id="saldoArts"
                                value={saldoArts}
                                loading={false}
                                erro={false}
                                disabled={false}
                                onChange={e => this.setState({ 
                                    qtd_avisar: e.value, 
                                    saldoArts: e.value 
                                })}
                                options={[
                                    { value: 5, label: "5 receitas para acabar" },
                                    { value: 10, label: "10 receitas para acabar" },
                                    { value: 15, label: "15 receitas para acabar" },
                                ]}
                                yesNo={true}
                                yesNoValue={sendAlert}
                                messageYesNo="Quero receber notificações"
                                onChangeYesNo={(e) => this.changeSendAlert(e)}
                                yesNoLeft="350px"
                                showDisabledYesNo={true}
                            />

                            {estado === 'SP' ? (
                                <>
                                    <div
                                        className="button-finish"
                                        style={{
                                            width: '100%',
                                            display: 'flex',
                                            flexDirection: 'row',
                                            justifyContent: 'center',
                                            alignItems: 'center',
                                            marginTop: '40px',
                                        }}
                                    >
                                        <Button
                                            width='100%'
                                            height='50px'
                                            value='SALVAR ART'
                                            outline={false}
                                            disabled={false}
                                            onClick={() => this.editArt()}
                                            loading={this.state.loading}
                                        />
                                    </div>


                                    <div
                                        className="button-finish"
                                        style={{
                                            width: '100%',
                                            display: 'flex',
                                            flexDirection: 'row',
                                            justifyContent: 'space-between',
                                            alignItems: 'center',
                                            marginTop: '40px',
                                        }}
                                    >
                                        <Button
                                            width='45%'
                                            height='50px'
                                            value='VOLTAR'
                                            outline={true}
                                            disabled={false}
                                            onClick={() => this.goBack()}
                                            loading={false}
                                        />
                                        <Button
                                            width='45%'
                                            height='50px'
                                            value='CONTRATOS'
                                            outline={true}
                                            disabled={false}
                                            onClick={() => this.addContract()}
                                            loading={false}
                                        />
                                    </div>
                                </>
                            ) : (
                                <>
                                    <div
                                        className="button-finish"
                                        style={{
                                            width: '100%',
                                            display: 'flex',
                                            flexDirection: 'row',
                                            justifyContent: 'center',
                                            alignItems: 'center',
                                            marginTop: '40px',
                                        }}
                                    >
                                        <Button
                                            width='100%'
                                            height='50px'
                                            value='SALVAR ART'
                                            outline={false}
                                            disabled={false}
                                            onClick={() => this.editArt()}
                                            loading={this.state.loading}
                                        />
                                    </div>
                                    {
                                        this.state.estado === 'NACIONAL' ? (
                                            <div
                                                className="button-relatorio"
                                                style={{
                                                    width: '100%',
                                                    display: 'flex',
                                                    flexDirection: 'row',
                                                    justifyContent: 'center',
                                                    alignItems: 'center',
                                                    marginTop: '30px',
                                                }}
                                            >
                                                <Button
                                                    width='100%'
                                                    height='50px'
                                                    value='RELATÓRIO PARA BAIXA DE TRT'
                                                    outline={!this.state.loadingR}
                                                    disabled={false}
                                                    onClick={() => this.relarioBaixaTrt()}
                                                    loading={this.state.loadingR}
                                                />
                                            </div>
                                        ) : (null)
                                    }
                                </>
                            )}

                        </form>
                    </Container>
                </ArtsAddContainer>

                <ModalAlert
                    show={this.state.showModalIe}
                    onHide={() => this.setState({ showModalIe: false })}
                    title="Informe a inscrição estadual da sua empresa"
                >
                    <h2 style={{
                        width: '100%',
                        textAlign: 'center',
                        marginBottom: '20px',
                        fontSize: '22px'
                    }}>Informe a inscrição estadual da sua empresa</h2>

                    <div style={{
                        width: '100%',
                        padding: '2% 20%',
                        margin: 'auto'
                    }}>
                        <Input
                            id="insestadual"
                            label="Inscrição Estadual"
                            value={insestadual}
                            maxlength="5000"
                            onChange={(e) => this.setState({ insestadual: e })}
                            onBlur={(e) => this.setState({ insestadual: e.target.value })}
                        />


                        <div className="button-finish" style={{ width: '100%', display: 'flex', flexDirection: 'row', justifyContent: 'center', marginTop: '40px' }}>
                            <Button
                                width='296px'
                                height='50px'
                                value='CADASTRAR'
                                outline={false}
                                disabled={insestadual.trim() === '' ? true : false}
                                onClick={() => this.enviaInscricao(insestadual)}
                                loading={this.state.loadingT}
                            />
                        </div>
                    </div>
                </ModalAlert>
            </>
        );
    }
}

export default withRouter(EditArts);
